<template>
  <v-checkbox v-bind="$attrs" v-on="$listeners">
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </v-checkbox>
</template>

<script>
export default {
  name: "ACheckbox",
};
</script>

<style scoped>
/* .v-application .primary--text {
    color: var(--v-primaryBase-base) !important;
    caret-color: var(--v-primaryBase-base) !important;
} */
::v-deep .primary--text {
  color: var(--v-neutralGray-base) !important;
}
</style>